import React from "react";
import styled from "styled-components";

import { above, below } from '../style/functions';
import Col from './col';



const ImageSplit = ({ left_image, right_image }) => {
  return (
    <ImageSplitWrapper>
      <Col className="split-image" fit>
        <img src={left_image.url} alt={left_image.alt} />
      </Col>
      <Col className="split-image" fit>
        <img src={right_image.url} alt={right_image.alt} />
      </Col>
    </ImageSplitWrapper>
  )
}

const ImageSplitWrapper = styled.section`
  align-items: stretch;
  display: flex;
  justify-content: stretch;
  position: relative;
  text-align: center;
  flex-wrap: wrap;

  .col {
    min-width: 100%;
  }

  ${above.tablet`
    .col {
      min-width: 0;
    }

    &.right .split-image {
      order: 2;
    }
  `}

  .split-content {
    display: flex;
    align-items: center;
    justify-content: stretch;
    padding: 8rem 0;
  }

  ${below.tablet`
    .split-content {
      padding: 8rem 2rem;

      > * {
        max-width: 36rem;
        margin: 0 auto;
      }
    }
  `}

  ${below.mobile`
    .split-content {
      padding: 4rem 1rem;
    }
  `}

  > .col {
    flex: 1 1 0;
  }
`



ImageSplit.defaultProps = {
  alt: "",
  background: "#FFF",
  color: "inherit"
}



export default ImageSplit
